import { useCurrentStore } from '@euler/app/flows/auth/context';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { useNavigation } from '@react-navigation/native';
import { StatusBar } from 'expo-status-bar';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { BoardHeader } from './components/BoardHeader';
import { JobBoard } from './components/job-board';
import { TaskBoard } from './components/task-board';
import { useBoardUnit } from './functions/useBoardUnit';
import { useKeepScreenAwake } from './functions/useKeepScreenAwake';
import { useNow } from './functions/useNow';
import { workshopBoardColors as colors } from './workshopBoardColors';
import { WorkshopBoardMode } from './workshopBoardMode';

/**
 * The workshop on a wall, on black for a large display the device is
 * mirrored to: the open tasks under today's counts, or their construction
 * jobs. The mode is in the link (`?mode=jobs`), so a display opens on its
 * board. It stays awake, and reloads and pages by itself.
 */
export const WorkshopBoardPage = wrapNavigatorScreen(
  ({ mode: linked }: { mode?: WorkshopBoardMode }) => {
    // From a link the param is any text.
    const mode: WorkshopBoardMode = linked === 'jobs' ? 'jobs' : 'tasks';
    useKeepScreenAwake();
    const u = useBoardUnit();
    const insets = useSafeAreaInsets();
    const navigation = useNavigation();
    const store = useCurrentStore();
    const now = useNow(15 * 1000);
    return (
      <View
        style={{
          flex: 1,
          gap: u(28),
          backgroundColor: colors.background,
          paddingTop: insets.top + u(32),
          paddingBottom: insets.bottom + u(24),
          paddingLeft: insets.left + u(48),
          paddingRight: insets.right + u(48),
        }}
      >
        <StatusBar hidden />
        <BoardHeader
          storeName={store?.name}
          now={now}
          mode={mode}
          onModeChange={next => navigation.setParams({ mode: next } as never)}
          onBack={() =>
            navigation.canGoBack()
              ? navigation.goBack()
              : navigation.navigate('Main' as never)
          }
        />
        {mode === 'jobs' ? <JobBoard now={now} /> : <TaskBoard now={now} />}
      </View>
    );
  },
  { headerShown: false, headerMode: 'float', title: '车间看板' },
);
